import { ChevronRight } from '@project-lary/react-material-symbols';
import { useGetETSTicketNotificationsCountSelector } from 'gcs-common/clients/api/entities/tickets/tickets-api-selectors';
import { CHAT_ROUTES } from 'gcs-common/constants/routes';
import Anchor from 'gcs-common/design-system/ui/anchor';
import IconButton from 'gcs-common/design-system/ui/icon-button';
import NotificationBadge from 'gcs-common/design-system/ui/notification-badge';
import FEATURE_FLAGS from 'gcs-common/helper/featureFlagsHelper';
import etsIcon from 'gcs-common/img/ets_icon.svg';
import { getIsAgent } from 'gcs-common/slices/currentUser/currentUserSelectors';
import { getHouseHasFeatureFlag, getSelectedHouseId } from 'gcs-common/slices/houses/housesSelectors';
import { getIsMobile } from 'gcs-common/slices/init/initSelectors';
import { getSidebarCollapsed } from 'gcs-common/slices/uiState/uiStateSelectors';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

// Gate is split from the content so the ticket notifications query only runs when ETS is enabled
const TicketsChannelItem = () => {
  const selectedHouseId = useSelector(getSelectedHouseId);
  const isMobile: boolean = useSelector(getIsMobile);
  const isAgent: boolean = useSelector(getIsAgent);
  const etsFeatureFlag = isMobile ? FEATURE_FLAGS.ETS_CRAFTSMAN_MOBILE : FEATURE_FLAGS.ETS_CRAFTSMAN_DESKTOP;
  const isEtsEnabled = useSelector(getHouseHasFeatureFlag(selectedHouseId, etsFeatureFlag));

  if (!isEtsEnabled || isAgent) {
    return null;
  }

  return <TicketsChannelItemContent />;
};

const TicketsChannelItemContent = () => {
  const navigate = useNavigate();
  const isSidebarCollapsed = useSelector(getSidebarCollapsed);
  const ticketNotificationsCount = useGetETSTicketNotificationsCountSelector();

  const navigateToTickets = () => {
    navigate(CHAT_ROUTES.TICKETS);
  };
  return (
    <Anchor
      onClick={navigateToTickets}
      className={`flex items-center gap-4 p-3 pl-4 no-underline hover:bg-neutral-3 active:bg-neutral-4 ${isSidebarCollapsed ? 'justify-center' : 'justify-between'}`}
    >
      <div className="flex items-center gap-2">
        <img className="h-10 w-10" src={etsIcon} alt="EtsIcon" />
        {!isSidebarCollapsed && (
          <div className="flex flex-col">
            <div className="flex items-center justify-center gap-2">
              <span className="text-base text-neutral-12">Ersatzteilanfragen</span>
            </div>
          </div>
        )}
      </div>
      <div className="flex items-center">
        {ticketNotificationsCount > 0 && (
          <NotificationBadge className="size-6 text-center text-white">{ticketNotificationsCount}</NotificationBadge>
        )}
        {!isSidebarCollapsed && (
          <IconButton
            Icon={ChevronRight}
            iconSize="size-6"
            className="cursor-pointer"
            size="m"
            variant="ghost_neutral"
          />
        )}
      </div>
    </Anchor>
  );
};

export default TicketsChannelItem;
